export interface Bonus {
  id: string
  title: string
  value: string
  desc: string
  benefit: string
  badgeClass: string
}

export const bonuses: Bonus[] = [
  {
    id: '1',
    title: '75 Massage Session Add-Ons & Mini Protocols',
    value: '15',
    desc: 'Ready-to-use 10–20 minute enhancements for targeted client needs: neck, shoulders, upper back, forearms, hands, hips, glutes, calves, feet, desk workers, post-workout recovery, relaxation, mobility, and gentle finishers.',
    benefit: 'Open. Add. Apply. Adapt.',
    badgeClass: 'bg-terracotta text-paper',
  },
  {
    id: '2',
    title: '50 Client Aftercare & Education Guides',
    value: '12',
    desc: 'Ready-to-share professional guides covering post-session expectations, relaxation and sports recovery, deep-pressure and gentle sessions, pressure communication, desk-work comfort, travel, standing-all-day clients, and lower-body recovery.',
    benefit: 'Extend professionalism beyond the massage table.',
    badgeClass: 'bg-burnt text-paper',
  },
  {
    id: '3',
    title: 'Mobile Massage Professional Setup Guide',
    value: '12',
    desc: 'The complete system for home visits, hotels, events, and on-site sessions: portable equipment, linen systems, hygiene, room assessment, privacy, arrival workflow, time management, cleanup, and professional reset.',
    benefit: 'Take your professional standard anywhere.',
    badgeClass: 'bg-sand text-clay border border-warmgray',
  },
  {
    id: '4',
    title: 'Massage Practice Growth & Client Retention Guide',
    value: '12',
    desc: 'Professional strategies for rebooking, client experience, session packages, retention, communication, scheduling, cancellation policies, workload organization, practice metrics, and professional scripts.',
    benefit: 'Build trust. Improve consistency. Strengthen your practice.',
    badgeClass: 'bg-clay text-paper',
  },
  {
    id: '5',
    title: 'Massage Therapist Career Longevity Guide',
    value: '12',
    desc: 'Hands, wrists, body mechanics, workload, and recovery strategies: thumb workload, wrist positioning, forearm fatigue, shoulder mechanics, table height, body-weight transfer, between-client resets, technique substitutions, and session spacing.',
    benefit: 'Protect your body so you can keep doing the work you care about.',
    badgeClass: 'bg-terracotta-deep text-paper',
  },
]
